<template>
  <div class="templateWrapper">
    <el-dialog
        :title="$t('other.a2462')"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <div class="waterWrapper">
            <div :class="{'waterProduct':true, 'active':imgUrl==item.watermarkUrl}" @click="imgUrl=item.watermarkUrl" v-for="(item,index) in imgList" :key="index">
                <img  :src="item.watermarkUrl" />
                <div class="dexlet" @click="deleteWaterImg(item,index)">x</div>
            </div>
            <div>
                <el-upload 
                action=""
                class="uploaImg"
                :http-request="uploaWaterImg"
                :show-file-list="false">
                
                <i class="el-icon-plus"></i>
                </el-upload>
            </div>
        </div>
        <div v-if="imageLength" class="okting">
          <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
          
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" type="warning">{{$t('other.a5')}}</el-button>
            <el-button type="primary" @click="addWaterImg(0)">{{$t('other.a1431')}}</el-button>
            <el-button type="primary" @click="addWaterImg(1)">{{$t('other.a1432')}}</el-button>
        </span>
        </el-dialog>

        <el-dialog
        :title="$t('other.a2463')"
        :visible.sync="updatPic"
        width="30%"
        >
        <div style="text-align: center">
                <el-upload
                class="avatar-uploader"
                action="https://erp.shopsbu.com/service/access/upload"
                :show-file-list="false"
                :headers="token"
                :on-success="handleAvatarSuccess"
                >
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updatPic = false">{{$t('other.a106')}}</el-button>
          <el-button type="primary" @click="imgConfirm()">{{$t('other.a279')}}</el-button>
        </span>
        </el-dialog>

    

    <div class="descTitle">
      <div>{{$t('other.a2464')}} >> {{$t('other.a2465')}}</div>
      <div class="tti">
        <el-button type="primary" @click="backTo()">{{$t('other.a1279')}}</el-button>
        <el-button type="danger" v-if="!putAway" @click="publishItem()">{{$t('other.a2466')}}</el-button>
        <el-button type="danger" v-if="putAway" @click="updataToDistribution()">{{$t('other.a2467')}}</el-button>
      </div>
    </div>
    <div class="itemWrapper">
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a2468')}}：</span>
        <!-- <span>{{tableList.categoryName ? tableList.categoryName : $t('other.a354')}}</span> -->
        <el-select size="mini" v-model="tableList.categoryName" placeholder="">
                                        <el-option
                                            v-for="item in categoryArr"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
      </div>
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a179')}}：</span>
        <el-input style="width:90%" v-model="tableList.name"></el-input>
      </div>
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a1390')}}：</span>
        <el-input
        style="width:90%"
          type="textarea"
          :rows="10"
          :placeholder="$t('other.a319')"
          v-model="tableList.description">
        </el-input>
      </div>
      <div class="itemDesc" style="align-items: center;width:auto;">
        <span class="olnklig">{{$t('other.a2832')}}：</span>
        <el-radio v-model="radioYP" label="1">{{$t('other.a191')}}</el-radio>
        <el-radio v-model="radioYP" label="2">{{$t('other.a192')}}</el-radio>
      </div>
    </div>

    <div class="itemImage">
      <div class="itemDesc">
        <div style="display:flex">
          <div>{{$t('other.a2469')}}</div>
          
          <el-upload 
          class="obikg"
          action=""
          multiple
          :http-request="handleUploadHttpRequest"
          :show-file-list="false">
          <el-button id="initSlide" size="mini" type="primary">{{$t('other.a2470')}}</el-button>
          </el-upload>
          <div><el-button class="obikg" type="primary" size="mini" @click="randomNum()">{{$t('other.a2471')}}</el-button></div>
          <div class="obikg"><el-button size="mini" type="primary" @click="getWaterImg()">{{$t('other.a291')}}</el-button></div>
        </div>
      </div>
      <div>
        <div class="okjnvk">
          <draggable
          class="oknolg"
          v-model="tableList.images"
          tag='ul'
          v-bind="dragOptions"
          @start="tableList.drag = true"
          @end="tableList.drag = false"
          >

          <span @mouseenter="active = imgUrl.positions" @mouseleave="active = -1"  v-for="(imgUrl,index) in tableList.images" :key="index">
            <div class="kgnlv"  ref="kgnlv">
              <img v-if="imgUrl.image" class="onkg" :src="imgUrl.image">
              <span v-if="imgUrl.image && active == imgUrl.positions" class="deleteImg" @click="deleteImg(index)">{{$t('other.a273')}}</span>
              <span v-if="!imgUrl.image" class="ytjg">
                <div style="text-align:center;font-size:20px">+</div>
                <div>{{$t('other.a2472')}}</div>
              </span>
              <img v-if="index == imgNum" class="onkg" :src="imgUrlCopy" >
            </div>
            <div class="iklng">{{$t('other.a657')}}{{index+1}}</div>
            
          </span>
          </draggable>
        </div>
      </div>
    </div>

    <div class="skuWrapper">
      <div class="itemDesc">
        <span>{{$t('other.a2473')}}：</span>
        <!-- <el-switch
          style="display: block"
          v-model="radio"

          @change="setProDuct()"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="以固定毛利率上架分销"
          inactive-text="以固定供货价上架分销">
        </el-switch> -->
        <el-radio-group v-model="radio2" @change="setProDuctCopy()">
          <el-radio :label="1">{{$t('other.a2474')}}</el-radio>
          <el-radio :label="2">{{$t('other.a2475')}}</el-radio>
          <el-radio :label="3">{{$t('other.a2476')}}</el-radio>
        </el-radio-group>
        <el-button  style="margin-left:30px" v-show="radio2 == '3' && hasGetRate" size="mini" type="primary" @click="hasGetRate=false,fixedRate=true">{{$t('other.a2477')}}</el-button>
        <span style="margin-left:30px;font-size:16px;color:red" v-show="radio2 == '3' && !hasGetRate">
          {{$t('other.a2478')}}：{{$t('other.a2479')}}={{$t('other.a2137')}}+{{$t('other.a2137')}}*
          <el-input v-show="fixedRate" size="mini" style="width:80px" v-model="rate" :placeholder="$t('other.a301')"></el-input> 
          <span  v-show="!fixedRate">{{rate}}%</span>
          ({{$t('other.a301')}})
        </span>
        <span style="margin-left:30px" v-show="radio2 == '3' && !hasGetRate ">
          <el-button v-show="!fixedRate" size="mini" type="primary" @click="fixedRate=true">{{$t('other.a93')}}</el-button>
          <el-button v-show="!fixedRate" size="mini" type="primary" @click="deleteCharge()">{{$t('other.a312')}}</el-button>
          <el-button v-show="fixedRate"  size="mini" type="primary" @click="updataPriceBycost()">{{$t('other.a38')}}</el-button>
          <el-button v-show="fixedRate"  size="mini" type="danger"  @click="fixedRate=false">{{$t('other.a146')}}</el-button>
        </span>
      </div>
      
        <el-table
              :data="tableList.variations"
              style="width: 100%"
              :key="itemKey"
              border
            >
              <el-table-column prop="outTradeNo" :label="$t('other.a217')" width="80">
                <template slot-scope="props">
                  <img  @click="changePic(props.row,props.$index)" v-if="props.row.image" class="picBox"  slot="reference" :src="props.row.image" style="width: 50px; height: 50px"  />
                  <span class="addImg" @click="changePic(props.row,props.$index)" v-else>+</span>
                </template>
              </el-table-column>
              
              <el-table-column label="sku" >
                <template slot-scope="props">
                  <span><el-input size="mini"  v-model="props.row.name" placeholder=""></el-input></span>
                </template>
              </el-table-column>

              <el-table-column v-if="radio2 == '3'" :label="$t('other.a219')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a2479')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       ￥</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(4)" v-model="costValue" :placeholder="$t('other.a307')"></el-input>
								</template>
                <template slot-scope="props">
                  <span>￥<el-input style="width:150px;margin-left:10px" size="mini" v-model="props.row.costCopy" :placeholder="props.row.costDesc"></el-input>
                  </span>
                </template>
              </el-table-column>

              <el-table-column v-if="radio2 == '1'" :label="$t('other.a219')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a2479')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       ￥</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue" :placeholder="$t('other.a307')"></el-input>
								</template>
                <template slot-scope="props">
                  <span>￥<el-input style="width:80px;margin-left:10px" size="mini" v-model="props.row.price" :placeholder="$t('other.a2608')"></el-input>
                    </span>
                </template>
              </el-table-column>

              <el-table-column v-if="radio2 == '2' " :label="$t('other.a301')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a301')}}%({{$t('other.a2481')}})</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(2)" v-model="fixGrossProfitRate" :placeholder="$t('other.a307')"></el-input>
                      
                </template>
                <template slot-scope="props">
                  <span>{{props.row.fixGrossProfitRate}}%</span>
                </template>
              </el-table-column>

              <el-table-column v-if="radio2 == '2'" :label="$t('other.a219')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a2479')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       ￥</span>
                     
								</template>
                <template slot-scope="props">
                  <span>￥{{props.row.price}}
                  </span>
                </template>
              </el-table-column>

              

              <el-table-column :label="$t('other.a2483')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a2482')}} </span>
                     
								</template>
                <template slot-scope="props">
                  <span>￥{{Paid(props.row.price)}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('other.a2484')" >
                <template slot-scope="props">
                   <span>{{props.row.stock}}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('other.a2137')" >
                <template slot-scope="props">
                   <span>{{props.row.cost}}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('other.a220')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a1464')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a2485')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       ￥</span>
                     <el-input size="mini" style="width:120px" @blur="setPrice(3)" v-model="wholesalePrice" :placeholder="$t('other.a307')"></el-input>
								</template>
                <template slot-scope="props">
                  <span>￥
                    <el-input style="width:80px;margin-left:10px" size="mini" v-model="props.row.wholesalePrice" ></el-input>
                  </span>
                </template>
              </el-table-column>

              <el-table-column  >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a2487')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a2486')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       </span>
                       <el-switch
                        style="display: block"
                        @change="setPrice(6)"
                        v-model="proportion"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-text="$t('other.a191')"
                        :inactive-text="$t('other.a192')">
                      </el-switch>
                    
								</template>
                <template slot-scope="props">
                  <span>{{props.row.proportion ? $t('other.a191') : $t('other.a192')}}</span>
                </template>
              </el-table-column>


              

              <el-table-column :label="$t('other.a2488')" >
                <template slot-scope="props">
                  <div><span style="margin-right:10px">{{getCur(props.row.country)}}</span>{{ props.row.priceList}}</div>
                  <div><span style="margin-right:10px">RMB</span>{{ props.row.minRmb}}</div>
                </template>
              </el-table-column>
               <!-- <el-table-column :label="$t('other.a33')" >
                <template slot-scope="props">
                  <div><el-button @click="deleteItem(props.row,props.$index)" size='mini' type="primary">{{$t('other.a273')}}</el-button></div>
                  
                </template>
              </el-table-column> -->
            
      </el-table>

    </div>

    <div class="skuWrapper">
        <div class="itemDesc">{{$t('other.a2489')}}：</div>
        <div class="okng">
          <span class="ttpoi">{{$t('other.a1255')}}/{{$t('other.a1256')}}/{{$t('other.a1257')}}：</span>
          <el-input class="inputBox" size="medium" type="text" v-model="tableList.packageHeight" :placeholder="$t('other.a1255')"></el-input>x
          <el-input class="inputBox" size="medium" type="text" v-model="tableList.packageLength" :placeholder="$t('other.a1256')"></el-input>x
          <el-input class="inputBox" size="medium" type="text" v-model="tableList.packageWidth" :placeholder="$t('other.a1257')"></el-input>cm
        </div>
        <div class="okng">
          <span class="ttpoi">{{$t('other.a1168')}}：</span>
          <el-input class="inputBox" size="medium" type="text" v-model="tableList.weight" :placeholder="$t('other.a1516')"></el-input>kg
        </div>

    </div>
    
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from "vuex";
import draggable from "vuedraggable"
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import dialogPlugin from '../component/diaload'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import jsonp from '../../../api/jsonp';
import mygoods from '../../../api/moudles/mygoods';
import neworderApi from '../../../api/moudles/newOrders'
import distributionApi from '../../../api/moudles/distribution'
import md5 from 'js-md5'
import html2canvas from 'html2canvas' 

export default {
data(){
return{
  radioYP:'2',
  changePicObj:{},
  proportion:false,
  wholesalePrice:null,
    originItem:null,
    onlineItem:null,
    imageUrl:'',
    itemKey:0,
    rate:null,
    fixedRate:false,
    putAway:false,
    updatPic:false,
    hasGetRate:true,
    radio:"1",
    radio2:1,
    percentage:0,
    imageLength:0,
    dialogVisible:false,
    active:-1,
    userId:null,
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    variations:[],
    tableList:[],
    variationId:null,
    calcNum:0,
    materialUrl:null,
    priceValue:null,
    costValue:null,
    imgNum:0,
    fixGrossProfitRate:null,
    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    imgList:[
      '',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/6e01a45243154306959f5fae1c99b37b.jpg',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/a704a09903c847f9a491b6604dda376b.jpg',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/9d2c717cef94441e90f856de046c6a72.jpg'
    ],
    imgUrl:null,
    imgUrlCopy:null,
    categoryArr:['家居用品','厨具','纺织品和软家具','家用电器','女装和内衣','穆斯林时尚','鞋','美容和个人护理','电话和电子产品','计算机和办公设备','宠物用品','婴儿和产妇','运动和户外','玩具和爱好','家具','工具和硬件','家庭改善','汽车和摩托车','时尚配饰','食品和饮料','健康','儿童时装','男装和内衣','行李和箱包','收藏','珠宝配件和衍生品']

}
},
components: {
    draggable
},
computed:{
  dragOptions() {
    return {
      animation: 200,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
    };
  },
},
watch:{
  calcNum(){
    this.percentage=Math.round(this.calcNum/this.imageLength*100)
  },
  dialogVisible(){
    if(!this.dialogVisible){
      this.imgUrl=null
    }
  },
  radio(){
    if(this.radio){
      console.log('jkmn')
      this.fixGrossProfitRate=5
      this.setPrice(2)
    }else{
      this.originItem.fixGrossProfitRate=null
    }
    console.log(this.originItem)
  },
},
created(){
    //获取该产品所有子sku绑定的线上产品
    // this.getGroupById()
    this.userId=this.userInfo ? this.userInfo.userId : null
    this.getData()
},
methods:{

  deleteItem(item,index){
    this.tableList.variations.splice(index,1)
    this.tableList.tiers[0].optionArray.splice(index,1)
    this.tableList.tiers[0].options=JSON.stringify(this.tableList.tiers[0].optionArray)
    let ttp=this.originItem.storeItems.findIndex(p => p.cusCode == item.cusCode)
    console.log(ttp)
    this.originItem.storeItems.splice(ttp,1)

    
    console.log('item',item)
    console.log('originItem',this.originItem)
  },

  setProDuctCopy(){
    console.log('radio2',this.radio2)
    if(this.radio2 == '1'){
        this.$confirm(this.$t('other.a2490'), this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            
        })
    }else if(this.radio2 == '2'){
        this.$confirm(this.$t('other.a2491'), this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            
        })
    }else if(this.radio2 == '3'){
      this.getCache()
      
        this.$confirm(this.$t('other.a2492'), this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            
        })
    }
    this.itemKey++

  },

  setProDuct(){
    this.itemKey++
    this.radio=!this.radio
    if(this.radio){
        this.$confirm(this.$t('other.a2493'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            this.radio=!this.radio
        })
    }else{
        this.$confirm(this.$t('other.a2491'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            this.radio=!this.radio
        })
    }

  },

  handleAvatarSuccess(res, file) {
  console.log(res,file)
  this.imageUrl = URL.createObjectURL(file.raw);
  },

  imgConfirm(){
    console.log(this.changePicObj)
    this.tableList.variations[this.changePicObj.type].image=this.imageUrl
    console.log(this.tableList.variations)
    console.log(this.imageUrl)
    this.updatPic=false
    this.imageUrl=null
    this.tableList=JSON.parse(JSON.stringify(this.tableList))
    console.log('tableList',this.tableList)
  },

  uploaWaterImg(params){

        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)
        

      
        console.log('formData',formData)

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.imgList.push({
                    watermarkUrl:res.data,
                    userId:this.userId
                })
                api
                .uploadWaterImg({
                    watermarkUrl:res.data,
                    userId:this.userId,
                    isUsed:true
                })
                .then(res => {
                    if(res.code === 200){
                        console.log('水印上传成功',res.data)
                    
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

  changePic(item,index){
    console.log(item,index)
    this.updatPic=true
    this.changePicObj=JSON.parse(JSON.stringify(item))
    this.changePicObj.type=index

    console.log('changePicObj',this.changePicObj)

    
},  

  deleteWaterImg(item,index){
        this.$confirm(this.$t('other.a564'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            api
            .deleteWaterImg({
                userId:this.userId,
                watermarkIds:[item.id]
            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a565'))
            this.imgList.splice(index,1)
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },
    addWaterImg(num){
      this.calcNum=0
        if(num == 1){//应用首图
          this.imageLength=1
            this.getWaterPiuture(this.tableList.images[0].image,this.imgUrl,0)
        }else if(num == 0){//应用全部
            this.imageLength=this.tableList.images.length
            this.tableList.images.forEach((p,index) => {
                if(p.image){
                    this.getWaterPiuture(p.image,this.imgUrl,index)
                }
            })
        }
    },

  

    getWaterPiuture(originImg,waterImg,index){
        console.log(originImg,waterImg)
        return new Promise((resolve) => {
            let that=this
            var canvas = document.createElement("canvas");
            canvas.width=800
            canvas.height=800
            let ctx=canvas.getContext('2d')
            let homeImg=originImg
            let picImg=new Image()
            picImg.setAttribute('crossOrigin', 'anonymous');
            picImg.src=homeImg
            
            picImg.onload = function() {
                ctx.drawImage(picImg,0,0,800,800);
                let base64=canvas.toDataURL('image/png')
                let image=new Image()
                image.src=waterImg
                image.setAttribute('crossOrigin', 'anonymous');
                image.onload = function() {
                    ctx.drawImage(image,0,0,800,800);
                    let base64=canvas.toDataURL('image/png')
                    var blob = that.dataURItoBlob(base64); // 上一步中的函数
                    var canvasOne = document.createElement('canvas');
                    var dataURL = canvasOne.toDataURL('image/jpeg', 0.5);
                    var fd = new FormData(document.forms[0]);
                    fd.append("file", blob, 'image.png');
                    if(JSON.parse(localStorage.getItem('userInfo')).shopeeShops){
                    fd.append('shopId',JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
                    fd.append('isUploadToShopee',true)
                    }
                    api
                    .uploadImg(fd)
                    .then(res => {
                        if(res.code == 200) {
                            resolve(res.data) 
                            
                    if(JSON.parse(localStorage.getItem('userInfo')).shopeeShops){
                            that.tableList.images[index].image=res.data.image_info_list[0].image_info.image_url_list[0].image_url
                            that.tableList.images[index].imageId=res.data.image_info_list[0].image_info.image_id
                          }else{
                      that.tableList.images[index].image=res.data
                    }
                    that.calcNum+=1
                            console.log('calcNum',that.calcNum)
                            // that.dialogVisible=false
                        }else{
                            that.$message.warning(res.msg)
                        }
                    })
                }  
            }


        })
          
    },

  dataURItoBlob(base64Data) {
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(base64Data.split(',')[1]);
      else
      byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
  },  

  getWaterImg(params){
        api
        .getWaterImg({
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.dialogVisible = true
        this.imgList=res.data
        }else{
        this.$message.warning(res.msg)
        }
        })
  },

  deleteImg(index){
    this.tableList.images.splice(index,1)
    for(var i=0,len=this.tableList.images.length;i<len;i++){
           
            this.tableList.images[i].positions=i;
            this.tableList.images[i].label="image"+ i;
           
      }
    console.log(this.tableList.images)
  },  

  randomNum(){
      let arr=JSON.parse(JSON.stringify(this.tableList.images))
     
      console.log(this.tableList.images)
    
      for(var i=0,len=arr.length;i<len;i++){
            var a=parseInt(Math.random()*len);
            var temp=arr[a];
            arr[a]=arr[i];
            arr[i]=temp;
           
      }

      for(var i=0,len=arr.length;i<len;i++){
           
            arr[i].positions=i;
            arr[i].label="image"+ i;
           
      }

      this.tableList.images=arr
      console.log('arr',arr)
      
  },

  getCache(){
        let ttp=null
        utils.getInfoByCache({
            cacheKey:'C_rate',
            userId:this.userId,
        }).then(res => {
          if(res !== null){
            this.hasGetRate=false
            this.rate=res

            this.tableList.variations.forEach(p => {
              p.price=((100+Number(this.rate))/100*p.cost).toFixed(2)
              p.costCopy=((100+Number(this.rate))/100*p.cost).toFixed(2)
            })
          }else{
            this.hasGetRate=true
            this.rate=5

          }
          
           
      
           console.log(this.rate)
           
           
        })
    },

  updataPriceBycost(){
    
    this.fixedRate=false
      utils.updateInfoByCache({
          cacheKey:'C_rate',
          userId:this.userId,
          cacheData:JSON.stringify(this.rate)
      }).then(res => {
          this.getCache()
         
      })
    
  },

  deleteCharge(){
     this.tableList.variations.forEach(p => {
        p.costCopy=null
        p.price=0
      })
    utils.updateInfoByCache({
          cacheKey:'C_rate',
          userId:this.userId,
          cacheData:null,
      }).then(res => {
        this.de
          // this.getCache()
         
      })
      this.hasGetRate=true
  },


  handleUploadHttpRequest(params){
    if(this.tableList.images.length > 9){
      this.$message.warning(this.$t('other.a2494'))
      return
    }
      console.log(params)
      if(params.file.size>(1048576*15)){
            this.$message.error('产品主图不能超过15M！');
        return
      }
      const _file=params.file
      let formData=new FormData()
      formData.append('file',_file)
                    if(JSON.parse(localStorage.getItem('userInfo')).shopeeShops){
      formData.append('shopId',JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
      formData.append('isUploadToShopee',true)
                    }

      api
      .uploadImg(formData)
      .then(res => {
          if(res.code === 200){
              console.log(res.data)
              let num=this.tableList.images.length
              
            if(JSON.parse(localStorage.getItem('userInfo')).shopeeShops){
              this.tableList.images.push({
                image:res.data.image_info_list[0].image_info.image_url_list[0].image_url,
                imageId:res.data.image_info_list[0].image_info.image_id,
                positions:num,
                label:'image'+num
              })
            }else{
              this.tableList.images.push({
                image:res.data,
                positions:num,
                label:'image'+num
              })
            }
          }else{
              this.$message.warning(res.msg)
          }
      })
  },

  getGroupById(){
    api
     .getStoreItemByGroupId({
         groupId:this.$route.query.groupId
     })
     .then(res => {
     if(res.code === 200 ){
       this.originItem=res.data
       this.originItem.putAway=true
       this.originItem.fixGrossProfitRate=null
       this.originItem.fixIssuePrice=null
       this.originItem.storeItems.forEach(p => {
         p.costCopy=null,
         p.costDesc=this.$t('other.a2495')+p.cost
         p.putAway=true
       })
       console.log('originItem',this.originItem)
     }else{
     this.$message.warning(res.msg)
     }
     })
  },

  








    setPrice(num){
      console.log(this.priceValue)
      if(num == 1) {
        if(this.priceValue !== '' && this.priceValue !== null){
          this.tableList.variations.forEach(p => {
            p.price=Number(this.priceValue).toFixed(2)
          })
        }
      }else if(num ==2){
        let fixGrossProfitRate=Number(this.fixGrossProfitRate)
        




        this.originItem.fixGrossProfitRate=Number(this.fixGrossProfitRate)
        console.log('55',this.originItem)
        if(this.fixGrossProfitRate !== '' && this.fixGrossProfitRate !== null){
          if(fixGrossProfitRate < 5){
          
          this.$message.warning(this.$t('other.a2496'))
          return
        }
          this.tableList.variations.forEach(p => {
            p.fixGrossProfitRate=Number(this.fixGrossProfitRate)
            p.price=(p.minRmb-p.minRmb*p.fixGrossProfitRate/100).toFixed(2)
          })

          
        }
      }else if(num == 3){
        if(this.wholesalePrice !== '' && this.wholesalePrice !== null){
          this.tableList.variations.forEach(p => {
            p.wholesalePrice=Number(this.wholesalePrice).toFixed(2)
            
          })

          
        }
      }else if(num == 4){
       
          this.tableList.variations.forEach(p => {
            p.costCopy=this.costValue ? Number(this.costValue).toFixed(2) : null
            p.price=this.costValue ? Number(this.costValue).toFixed(2) : 0
          })
        
      }else if(num == 6){
        this.tableList.variations.forEach(p => {
            p.proportion=this.proportion
          })
      }
    },


    chooseItem(){
      let item=this.onlineItem.find(item => item.variationId == this.variationId)
      this.getOnlineProduct(item.country,item.itemId,item.shopId)
    },

    backTo(){
      this.$router.push({
          path:'/stockProduct/productDetail',
          query:{
              groupId:this.$route.query.groupId,
              type:this.$route.query.type
          }
      })
    },


    updataToDistribution(){
      console.log(this.tableList)
      this.tableList.tiers[0].options=JSON.stringify(this.tableList.variations.map(p => {return p.name}))
      this.tableList.tiers[0].positions=0
      this.tableList.tiers[0].productId=0
      this.tableList.userId=this.userId
      this.tableList.productId=this.originItem.productId
      console.log(this.originItem.storeItems)
      this.originItem.storeItems.forEach(p => {
        let ttp=this.tableList.variations.find(item => item.cusCode == p.cusCode)
        p.price=ttp ? Number(ttp.price) : null
        console.log(ttp)
        p.wholesalePrice=ttp ? Number(ttp.wholesalePrice) : null 
        p.proportion=ttp.proportion ? 0.3 : null 
      })

      if(this.tableList.name&&this.tableList.name.length > 120||!this.tableList.name){
        this.$message.warning(this.$t('other.a2497'))
        return
      }

      let type=0
      this.tableList.variations.forEach(p => {
        p.price=Number(p.price)
        if(p.name.length > 20){
          type=1
          return
        }

        if(!p.price){
          type=2
          return
        }
      
      })
      if(type == 1){
        this.$message.warning(this.$t('other.a2498'))
        return
      }

      if(type == 2){
        this.$message.warning(this.$t('other.a2500'))
        return
      }


      
      this.tableList.tiers[0].images=this.tableList.tiers[0].images.filter(p => {
        if(p){
          return p
        }
      })
      
      this.tableList.tiers[0].optionArray=this.tableList.variations.map(p => {
        p.variationSku=p.name
        return p.name
      })

      this.tableList.freeDistribution = this.radioYP == 1?true:false
      console.log('tableList',this.tableList)
      console.log('originItem',this.originItem)
    



      api
      .updataProduct(this.tableList)
      .then(res => {
        if(res.code == 200){
          api
          .updateProductId({
          groupId:this.$route.query.groupId,
          storeId:this.$route.query.storeId,
          productId:res.data.productId,
          userId:this.userId
          })
          .then(res => {
              if(res.code === 200){
                this.originItem.categoryName = this.tableList.categoryName
                this.originItem.freeDistribution = this.tableList.freeDistribution
                  distributionApi
                  .putAwayToDistribution(this.originItem)
                  .then(res => {
                  if(res.code === 200 ){
                  console.log('desc',res.data)
                  this.$message.success(this.$t('other.a2501'))
                 
                  }else{
                  this.$message.warning(res.msg)
                  }
                  })

              }else{
                  this.$message.warning(res.msg)
              }
          })
          
        }else{
          this.$message.warning(res.msg)
        }
      })

    },

    publishItem(){
      this.tableList.tiers[0].options=JSON.stringify(this.tableList.variations.map(p => {return p.name}))
      this.tableList.tiers[0].positions=0
      this.tableList.tiers[0].productId=0
      this.tableList.userId=this.userId

      this.originItem.storeItems.forEach(p => {
        let ttp=this.tableList.variations.find(item => item.cusCode == p.cusCode)
        p.price=ttp ? Number(ttp.price) : null
        p.wholesalePrice=ttp ? Number(ttp.wholesalePrice) : null 
        p.proportion=ttp.proportion ? 0.3 : null 
      })
      
      if(this.tableList.name&&this.tableList.name.length > 120||!this.tableList.name){
        this.$message.warning(this.$t('other.a2497'))
        return
      }

      let flag=false
      this.tableList.variations.forEach(p => {
        console.log(p.name.length)
        if(p.name.length > 20){
          flag=true
        }
      
      })
      if(flag){
        this.$message.warning(this.$t('other.a2498'))
        return
      }

      console.log('flag',flag)

      
        console.log('tableList',this.tableList)
        console.log('originItem',this.originItem)
        this.tableList.tiers[0].images=this.tableList.tiers[0].images.filter(p => {
          if(p){
            return p
          }
        })
        
        this.tableList.tiers[0].optionArray=this.tableList.variations.map(p => {
          p.variationSku=p.name
          return p.name
        })

        this.tableList.freeDistribution = this.radioYP == 1?true:false
    



      api
      .updataProduct(this.tableList)
      .then(res => {
        if(res.code == 200){
          api
          .updateProductId({
          groupId:this.$route.query.groupId,
          storeId:this.$route.query.storeId,
          productId:res.data.productId,
          userId:this.userId
          })
          .then(res => {
              if(res.code === 200){
                this.originItem.categoryName = this.tableList.categoryName
                this.originItem.freeDistribution = this.tableList.freeDistribution
                  this.$message.success(this.$t('other.a2502'))
                  distributionApi
                  .putAwayToDistribution(this.originItem)
                  .then(res => {
                  if(res.code === 200 ){
                  console.log('desc',res.data)
                  this.$message.success(this.$t('other.a2503'))
                 
                  }else{
                  this.$message.warning(res.msg)
                  }
                  })

              }else{
                  this.$message.warning(res.msg)
              }
          })
          
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    getData(){
        let obj=JSON.parse(localStorage.getItem('onlineItem'))
        if(obj){
            this.variations=obj.variations
            // console.log('onlineItem',this.onlineItem)
            console.log('variations',this.variations)
            this.getOnlineProduct()
        }
    },


    //itemId,shopId获取shopee线上的产品信息

    getOnlineProduct(){
      api
     .getStoreItemByGroupId({
         groupId:this.$route.query.groupId
     })
     .then(res => {
         if(res.code == 200){
            this.putAway=res.data.putAway
            this.originItem=res.data
            this.originItem.putAway=true
            this.originItem.fixGrossProfitRate=null
            this.originItem.fixIssuePrice=null
            this.radioYP = this.originItem.freeDistribution?'1':'2'
            this.originItem.storeItems.forEach(p => {
                p.costCopy=null,
                p.costDesc=this.$t('other.a2495')+p.cost
                p.putAway=true
                if(p.proportion == 0.3){
                this.proportion=true
                }
            })

            console.log('originItem',this.originItem)

            
            let obj={
                attributes:[],
                productShops:[],
                categoryId:0,
                modelId:null,
                name: null,
                images:[],
                drag: false,
                status:'NORMAL',
                description:null,
                packageHeight:this.variations[0].packageHeight,
                packageLength:this.variations[0].packageLength,
                packageWidth:this.variations[0].packageWidth,
                country:'ROOT',
                weight:this.variations[0].weight,
                price:null,
                hasVariation:false,
                variations:this.variations,
                variationsCopy:[],
                tiers:[],
                logistics:[],
                userId:null
            }

            obj.description=null
            obj.name=null
            obj.sourceUrl=null
            obj.categoryId=null
            obj.categoryName=null
            obj.tiers[0]={}
            obj.tiers[0].name='规格'
            obj.tiers[0].images=[]
            obj.tiers[0].optionArray=[]
            this.variations.forEach(p => {
            obj.tiers[0].images.push(p.image)
            obj.tiers[0].optionArray.push(p.name)
            })

            obj.tiers[0].imagesUrl=JSON.stringify(obj.tiers[0].images)
            obj.tiers[0].options=JSON.stringify(obj.tiers[0].optionArray)
            obj.tiers[0].positions=0

            obj.categoryName = this.originItem.categoryName?this.originItem.categoryName:'家居用品'
        

            this.tableList=obj
            console.log('tableList',this.tableList)
            console.log('onlineItem',this.onlineItem)
            console.log(this.$route.query.groupId)
            mygoods
            .getProductByGroupId({groupId:this.$route.query.groupId })
            .then(res1 => {
              console.log(res1)
              if(res1.code == 200&&res1.data){
              for(let i = 0;i<res1.data.variations.length;i++){
                res1.data.variations[i].name = res1.data.variations[i].variationSku
                res1.data.variations[i].wholesalePrice = res1.data.variations[i].storeItem?res1.data.variations[i].storeItem.wholesalePrice:0
              }
              res1.data.categoryName = res1.data.categoryName?res1.data.categoryName:'家居用品'
              this.tableList=JSON.parse(JSON.stringify(res1.data))
              this.tableList.variations=this.variations
              }
            })
         }
     })





        
    
    },
    getCur(code){
      return utils.getCurrency(code)
    },

    getRmb(country,price){
      return utils.interestRateConversion(country,price)
    },
    Paid(price){
      let ttp=null
      if(price){
        ttp=price-price*0.05
      }
      return ttp ? ttp.toFixed(2) : ttp
    },
}
}

</script>
<style lang="scss" scoped>

.templateWrapper{
  background-color: #eee;
  box-sizing: border-box;
  padding: 0 0 30px 0;


  /deep/ .el-radio__label{
    font-size: 18px;
  }

  /deep/ .el-radio__inner{
    width: 18px;
    height: 18px;
  }


  .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
  }
  .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px solid #000;
  border-radius: 5px;
  }


  .avatar {
  width: 178px;
  height: 178px;
  display: block;
  }

  .course-container {
  height: 1024px;
  width: 724px;
}
 .course {
     z-index: 1;
     left: 74px;
     top: 100px;
     position: absolute;
 }
 .code {
    z-index: 2;
    position: absolute;

    width: 150px;
    height: 150px;
 }




  .oknolg{
    display: flex;
  }

  .waterWrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-height: 300px;
    overflow-y: scroll;
    background-color: #eee;
  }

  .waterProduct{
    width: 90px;
    height: 90px;
    overflow: hidden;
    margin:3px ;
    cursor: pointer;

    border: 1px solid red;

    img{
      width: 100%;
    }
  }


  .skuWrapper{
    margin-top: 50px;
    border-top: 1px solid #eee;
    padding-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 25px 7px 0 7px;
    padding: 16px 10px 25px 10px;
    border-radius: 3px;
    cursor: pointer;


    .addImg{
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 3px;
      border: 1px solid #eee;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
      
    }

    .picBox{
      display: inline-block;
      border-radius: 3px;
      border: 1px solid #eee;
    }

    .inputBox{
      width: 80px;
      margin: 0 5px;
    }

    .okng{
      margin-bottom: 20px;
    }

    .ttpoi{
      display: inline-block;
      width: 120px;
      text-align: right;
    }

    .itemDesc{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
     

     
    }
  }

  .descTitle{
    padding: 10px 0;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    display: flex;
    

    .tti{
      margin-right: 50px;
    }
    

    
  }

  .okting{
    margin-top: 20px;
  }

  .itemImage{
    background-color: #fff;
    box-sizing: border-box;
    height: 300px;
    margin: 0 7px;
    padding: 16px 10px 25px 10px;
    border-radius: 3px;
    
    .itemDesc{
      padding-top: 10px;
      border-top: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      

      .obikg{
        margin-left: 30px;
      }

    }
     
  }

  .itemWrapper{
    
    background-color: #fff;
    box-sizing: border-box;
    
    margin: 30px 7px;
    padding: 16px 10px 25px 10px;
    border-radius: 3px;
    // border: 1px solid #eee;
  }

  .itemDesc{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
    display: flex;

     .olnklig{
        display: inline-block;
        width: 120px;
      }
  }

  .iklng{
    
    text-align: center;
    
    
  }

  .kgnlv{
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin: 0 5px;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #eee;
    width:100px;
    height: 100px;

    .deleteImg{
      position: absolute;
      display: inline-block;
      width: 100%;
      text-align: center;
      font-size: 12px;
      padding: 3px 0;
      left:50%;
      transform: translateX(-50%);
      bottom: 0;
      z-index: 99;
      background-color: rgba(0,0,0,.87);
      color: #fff;
    }

    .onkg{
      position: absolute;
      left:0;
      top: 0;
    }



    .ytjg{
      display: inline-block;
      position: absolute;
      font-size: 12px;
      top:30%;
      left:50%;
      transform: translate(-50%,-50%);
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
    }

    

    img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
     
    }
  }

  .waterWrapper{
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            max-height: 300px;
            overflow-y: scroll;
            background-color: #eee;
        }


        .active{
            box-sizing: border-box;
            border: 3px solid #409EFF;
        }

        .waterProduct{
            width: 90px;
            height: 90px;
            overflow: hidden;
            margin:3px ;
            cursor: pointer;
            position: relative;
           


            .dexlet{
                position: absolute;
                right: 3px;
                top: 3px;
                width: 10px;
                height: 10px;
                text-align: center;
                line-height: 10px;
                background-color:#fff;
                padding: 5px;
                border-radius: 50px;
                color: #000;
            }

            img{
            width: 100%;
            }
        }

        .uploaImg{
            border: 1px solid #000;
            width: 90px;
            height: 90px;
            margin: 3px;
        }

        /deep/ .el-icon-plus{
            font-size: 25px;
            margin: 30px 0 0 30px;
        }
}

</style>